import type { Extra } from '~/utils/error'
import { ErrorWithExtra } from '~/utils/error'

export class ConvertToOfflineError extends ErrorWithExtra {
  constructor(message: string, extra?: Extra) {
    super('ConvertToOfflineError', message, extra)
  }
}
